/*** IMPORTS FROM imports-loader ***/
var define = false;

import { slice } from './_setup.js';

// Returns everything but the last entry of the array. Especially useful on
// the arguments object. Passing **n** will return all the values in
// the array, excluding the last N.
export default function initial(array, n, guard) {
  return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
}




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/initial.js
// module id = 74
// module chunks = 0